module.exports = "https://www.gc-pro.gnp.com.mx/68b3345190127f54e7b9ebf9db8de351.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/carrusel-02.gif
// module id = 8071
// module chunks = 0